import React, { useState } from 'react';
import { MessageCircle, X, Calendar } from 'lucide-react';

const WA_NUMBER = '6580179673';
const WA_MESSAGE = encodeURIComponent("Hi, I'm exploring India–Singapore expansion. Would like to understand how Bizenntrum can help.");

const FloatingCTA = () => {
  const [open, setOpen] = useState(false);

  const scrollToForm = () => {
    setOpen(false);
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="floating-cta-wrap" data-testid="floating-cta">
      {open && (
        <div className="floating-menu" data-testid="floating-menu">
          <a
            href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="floating-option floating-wa"
            data-testid="floating-whatsapp"
          >
            <MessageCircle size={18} />
            <span>WhatsApp</span>
          </a>
          <button className="floating-option floating-call" onClick={scrollToForm} data-testid="floating-book-call">
            <Calendar size={18} />
            <span>Book Strategy Call</span>
          </button>
        </div>
      )}

      <button
        className={`floating-btn ${open ? 'floating-btn-active' : ''}`}
        onClick={() => setOpen(!open)}
        data-testid="floating-toggle"
        aria-label="Talk to Advisor"
      >
        {open ? <X size={22} /> : <MessageCircle size={22} />}
        {!open && <span className="floating-label">Talk to Advisor</span>}
      </button>

      {!open && (
        <span className="floating-tooltip">Quick question? Message us</span>
      )}
    </div>
  );
};

export default FloatingCTA;
